<template>
  <div id="pageGroup" class="pagination">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.pageNumber"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total">
    </el-pagination>
  </div>
</template>

<script>

export default {
  name: "pageGroup",
  props: {
    pageInfo: {
      type: Object,
      default: function () {
        return {
          pageNumber: 1, //默认在第一页
          pageSize: 10, //默认每页显示1条数据
          total: 1, //默认总条数为一条
        }
      }
    }
  },
  methods: {
    // 获取page-sizes里的每页显示几条数据的值，赋给我们自定义的每页显示数量的变量pageNum
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageChange();
    },
    // 确定当前页面后刷新页面
    handleCurrentChange(pageNumber) {
      this.pageInfo.pageNumber = pageNumber;
      this.pageChange();
    },
    // 展示页面信息，触发父组件中特定的pageChanged函数
    pageChange() {
      this.$emit('pageChange')
    },
  }
}

</script>

<style>
  #pageGroup {
    text-align: right;
    padding-right: 19px;
    padding-top: 7px;
  }
</style>



// WEBPACK FOOTER //
// src/components/template/PageGroup.vue